export function kindsToClassName(kinds) {
  return 'mirrorsharp-has-kind ' + kinds.map(kind => 'mirrorsharp-kind-' + kind).join(' ');
}